(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["@operational-transformation/plaintext"] = factory();
	else
		root["@operational-transformation/plaintext"] = factory();
})(this, function() {
return 